import axios from 'axios';
import { LinkinBioHeaderProps, LinkinBioArticle } from 'socialflow-linkinbio';
import END_POINTS from '../constants';

const SocialConstants: Dictionary = {
  apple: 'apple',
  facebook: 'facebook',
  instagram: 'instagram',
  linkedin: 'linkedin',
  pinterest: 'pinterest',
  twitter: 'twitter',
  tiktok: 'tiktok',
  youtube: 'youtube',
};

type MetaDataType = {
  service_user_id: string;
  page_handle: string;
  client_id: 0;
  homepage_url: string;
  page_avatar_url: string;
  banner_story: {
    type: string;
    alt_text: string;
    link: string;
    image_url: string;
    service_message_id: string;
  };
  display_settings: Record<string, unknown>;
  cta: Cta[];
  social_links: SocialLinks[];
  description: string;
};

type Cta = {
  type: string;
  text: string;
  link: string;
};

type SocialLinks = {
  supported_service_type: string;
  url: string;
  alt_text: string;
};

type PostType = {
  service_user_id: 'string';
  service_message_id: 'string';
  publish_time_epoch: 0;
  link: 'string';
  caption: 'string';
  fullsize_image_url: 'string';
  media_type: 'string';
};

const formatAccountMetadata = (d: MetaDataType): LinkinBioHeaderProps | null => {
  if (!d || Object.keys(d).length < 1) return null;
  return {
    avatar: d.page_avatar_url,
    link: d.homepage_url,
    banner: d.banner_story
      ? {
          bannerUrl: d.banner_story.image_url,
          altText: d.banner_story.alt_text,
          serviceMessageId: d.banner_story.service_message_id,
          link: d.banner_story.link,
        }
      : undefined,
    ctaButtons:
      d?.cta?.map((cta: Cta, index) => {
        return {
          id: index,
          text: cta.text,
          link: cta.link,
        };
      }) || undefined,
    socialMediaButtons:
      d?.social_links?.reduce((obj, { supported_service_type, url }) => {
        obj[SocialConstants[supported_service_type]] = url;
        return obj;
      }, {} as Dictionary) || undefined,
    displaySettings: d.display_settings,
    companyName: d.page_handle,
    hasMoreArticles: true,
    subHeading: d?.description,
  };
};

type Dictionary = {
  [key: string]: string;
};

export const getAccountMetadata = async (pageHandle: string) => {
  const url = `${END_POINTS.GET_ACCOUNT}/${pageHandle}`;
  return axios
    .get<MetaDataType>(url)
    .then((res) => formatAccountMetadata(res.data))
    .catch((err) => {
      console.error(err);
    });
};

const formatPostData = (posts: PostType[] = []): LinkinBioArticle[] => {
  //TODO remove the math.random once api is updated
  return posts.map((d) => ({
    serviceMessageId: d.service_message_id || Math.floor(Math.random() * 100000000),
    publishTimeEpoch: d.publish_time_epoch,
    link: d.link,
    fullSizeImageUrl: d.fullsize_image_url,
    altText: d.caption,
    mediaType: d.media_type,
  }));
};
export const getPosts = async (pageHandle: string, ts?: number) => {
  let url = `${END_POINTS.GET_POSTS}/${pageHandle}`;
  if (ts) {
    url = `${url}/${ts}`;
  }
  return axios
    .get<PostType[]>(url)
    .then((res) => formatPostData(res.data))
    .catch((err) => {
      console.error(err);
    });
};
